import React, {useState} from 'react';
import { ScrollPanel } from 'primereact/scrollpanel';
import { ProgressBar } from 'primereact/progressbar';
import { IOpcion } from '../../../interfaces/OpcionReembolso';
import { useReembolsoExpressContext } from '../context/reembolsoExpress.context';

interface dataDisponible {
    monto: number,
    reembolso: string,
    presentacion: string,
    acumulado: number,
    fecha: Date,
    producto: string
}

interface IState {
    loading: boolean,
    confirmar: boolean,
    opcion?: IOpcion[],
    totalIntTransferencia: number,
    totalIntDigital: number,
    visible: boolean
}



const Disponibles = () => {
    const reembolsoState = useReembolsoExpressContext()
    //const [state,setState] = useState({ loading: true, opcion: props.opcion, totalIntDigital: 0, totalIntTransferencia: 0})

    const[confirmar,setConfirmar] = useState(false)
    const [visible,setVisible] = useState(false)
    
    const onHide = ()=> {
        setVisible(false);
    }
    const displayValueTemplate = (value: number) => {
        return (
            <React.Fragment>
                <b className={value <= 50 ? 'colorBlack' : 'colorWhite'}>{value}%</b>
            </React.Fragment>
        );
    }

    let monto = reembolsoState.state.monto;

    let data = reembolsoState.state.dataDisponible;
    let hoy = new Date();
    if (data == null) {
        return (
            <div>
                <ScrollPanel className="refund-panel-size">
                </ScrollPanel>
            </div>
        )
    }
    else {
        return (
            <div className="refund-panel-size">
                <ScrollPanel className="pagos-programados-lista">
                    <ul className="activity-list">
                        {
                            data.map(function (item:any) {
                                let porcentaje = 0;
                                let montoUsado = 0;
                                let montoString = item.monto.toLocaleString(undefined, { maximumFractionDigits: 2, minimumFractionDigits: 2 });
                                porcentaje = (monto < item.acumulado ?
                                    (monto > (item.acumulado - item.monto) ?
                                        (((monto - (item.acumulado - item.monto)) * 100) / item.monto)
                                        : 0)
                                    : 100);
                                montoUsado = (monto < item.acumulado ?
                                    (monto > (item.acumulado - item.monto) ?
                                        (monto - (item.acumulado - item.monto))
                                        : 0)
                                    : item.monto);
                                if (!(porcentaje <= 0 && confirmar)) {
                                    let fecha: Date = new Date(item.fecha.toString());

                                    var dd = fecha.getDate();
                                    var mm = fecha.getMonth() + 1;
                                    var sdd = dd.toString();
                                    var smm = mm.toString();
                                    var yyyy = fecha.getFullYear();
                                    if (dd < 10) {
                                        sdd = '0' + dd.toString();
                                    }
                                    if (mm < 10) {
                                        smm = '0' + mm.toString();
                                    }
                                    let fechaReembolso = sdd + '/' + smm + '/' + yyyy;

                                    let diasFaltantes = ((fecha.getTime() - hoy.getTime()) / (1000 * 3600 * 24)).toLocaleString(undefined, { maximumFractionDigits: 0, minimumFractionDigits: 0 });

                                    let porcentajeString = porcentaje.toLocaleString(undefined, { maximumFractionDigits: 0, minimumFractionDigits: 0 });
                                    porcentaje = +porcentajeString;

                                    return (
                                        <li key={item.reembolso.toString()}>
                                            <div className="n3 mb-2">
                                                <ProgressBar value={porcentaje} displayValueTemplate={displayValueTemplate} ></ProgressBar>
                                                <div className="row">
                                                    <div className="col-4 text-right">
                                                        <p>Monto Neto:</p>
                                                    </div>
                                                    <div className="col-8 text-right">
                                                        <p>
                                                            $
                                                        {montoUsado.toLocaleString(undefined, { maximumFractionDigits: 2, minimumFractionDigits: 2 })}
                                                            /
                                                        <span className="montoReembolsoProgramado">${montoString}</span>
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-4 text-right">
                                                        <p>Presentación:</p>
                                                    </div>
                                                    <div className="col-8">
                                                        <p>{item.presentacion}</p>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-4 text-right">
                                                        <p>Producto:</p>
                                                    </div>
                                                    <div className="col-8">
                                                        <p>{item.producto}</p>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-4 text-right">
                                                        <p>Fecha de pago:</p>
                                                    </div>
                                                    <div className="col-8">
                                                        <p>{fechaReembolso}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    )
                                }
                            })
                        }
                    </ul>
                </ScrollPanel>
            </div >
        )
    }
}
export default Disponibles
